<template>
  <div class="home">
    Seja bem vindo ao backoffice, em breve teremos mais informações nessa tela.
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  computed: {
    ...mapGetters([
      'token',
      'email'
    ])
  },
  beforeMount() {
    this.$vs.loading.close();
  },
  beforeCreate() {
    this.$vs.loading.close()
  },
  mounted() {
    this.$vs.loading.close();
  },
  created() {
    this.$vs.loading.close();
  }
}
</script>

<style scoped>
.home {
  margin-top: 3%;
}
</style>